module.exports = __webpack_public_path__ + "static/media/18.c79673bc.jpg";